"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasFooter = exports.hasFooter = function hasFooter(columns) {
  return columns.length !== 0 && columns.find(function (cell) {
    return Boolean(cell.footer);
  });
};
var hasHeader = exports.hasHeader = function hasHeader(columns) {
  return columns.find(function (cell) {
    return Boolean(cell.header);
  });
};